import { FC } from 'react'

import { BodyProps } from './types'

const Body: FC<BodyProps> = ({ children, className }) => {
  return <div className={`flex w-full ${className} `}>{children}</div>
}

export default Body
